import State from '../core/State';
import produce, { Draft } from 'immer';

export const addNonFatalError = (error: Error) =>
  produce((draft: Draft<State>) => {
    draft.nonFatalErrors = draft.nonFatalErrors.concat(error);
  });

export const removeNonFatalError = (error: Error) =>
  produce((draft: Draft<State>) => {
    draft.nonFatalErrors = draft.nonFatalErrors.filter((err) => err !== error);
  });
